//@flow

// Vendors
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { FormActions, FormActionsItem } from '../../';
import { Modal } from '../../modals';
import { TxButton, TxButtonMode } from 'texkit-ui';

//Actions
import { closeModal } from '../../../../reducers/modal/modalActions';

// Selectors
import { selectModalData } from '../../../../reducers/modal/modalSelectors';

// Styles
import './announcement-modal.scss';

const AnnouncementModal = () => {
  const dispatch = useDispatch();
  const handleClose = () => dispatch(closeModal('AnnouncementModal'));
  const content = useSelector(selectModalData);

  if (!Object.keys(content).length) {
    return null;
  }

  return (
    <Modal
      name="AnnouncementModal"
      className="announcement-modal"
      disableOnClickOutside={true}
    >
      <h2 className="h1 modal-title">{content.heading}</h2>
      <div
        className="modal-content"
        dangerouslySetInnerHTML={{ __html: content && content.messageBody }}
      />
      <FormActions align="center">
        <FormActionsItem>
          <TxButton
            onClick={handleClose}
            mode={TxButtonMode.Primary}
            type="button"
          >
            {content && content.buttons && content.buttons.at(0).label_en}
          </TxButton>
        </FormActionsItem>
      </FormActions>
    </Modal>
  );
};

export default AnnouncementModal;
